<template>
    <div style="height:100%" class="menue">
        <template v-for="item in getMenu">
            <el-menu-item :index="item.menuUrl?item.menuUrl:item.id+''" :key="item.id" v-if="!item.children">
                <i :class="[{icon:true,iconfont:true},item.menuIcon]" style=" font-size:20px;"></i>
                <span slot="title">{{item.menuName}}</span>
            </el-menu-item>
            <el-submenu :index="item.menuUrl?item.menuUrl:item.id+''"  v-else :key="item.id">
                <template slot="title">
                    <i :class="[{icon:true,iconfont:true},item.menuIcon]" style="font-size:20px;"></i>
                    <span :class="{'hidden-close':isCollapse}">{{item.menuName}}</span>
                </template>
                <common-menu :getMenu="item.children"></common-menu>
            </el-submenu>
        </template>
    </div>
</template>
<script>
export default {
    name:'CommonMenu',
    props:{
        getMenu:Array,
        isCollapse:Boolean
    },
    data(){
        return{
        }
    },
    methods:{
        
    }
}
</script>
<style >
.menue .el-menu-item,.menue .el-submenu__title{
    height:42px !important;
    line-height: 42px !important;
}
.menue .el-menu--inline .el-menu-item{
    height:34px !important;
    line-height: 34px !important;
}
/* .el-menu-item:focus,.el-menu-item:hover{
    color:#1890FF!important;
} */
/* .el-submenu__title .el-icon-s-tools i:hover{
     color:#00B103 !important;
}
.el-menu-item:focus,.el-menu-item:hover{
    background: #00B103 !important;
    color:#fff!important;
}
.el-submenu__title:focus, .el-submenu__title:hover{
    background: #00B103 !important;
    color:#fff!important;
} */
.el-menu-item.is-active{
    font-size:15px;
    font-weight: 500;
}
.hidden-close{
    display: none;
}
.menue .el-icon-arrow-right{
    display: none;
}
/* .menue .el-submenu__title:hover i,.menue .el-menu-item:hover i{
    color:#fff;
} */
</style>



// WEBPACK FOOTER //
// src/views/pc/components/Menu.vue